var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 let { is_advantage, is_essentials, is_basic, office, agent, property_type, builder_branding } = options; 
__p+='\n<div class="qv-branding">\n  ';
 if(property_type == 'for_sale') { 
__p+='\n    ';
 if(is_advantage) { 
__p+='\n      <div class="row pos-relative">\n        ';
 if(office || agent) { 
__p+='\n         <div class="branding-bar" '+
((__t=( office && office.photo_attribution.accent_color ? `style="background-color:${office.photo_attribution.accent_color}"` : '' ))==null?'':__t)+
'></div>\n        ';
 } 
__p+='\n        <div class="wrapper">\n          ';
 if(agent) { 
__p+='\n            <div class="col-qv-md-6 col-qv-sm-12 branding-wrapper">\n              <div class="component_business-card  '+
((__t=( agent.photo_attribution.photo? '' : 'no-media' ))==null?'':__t)+
'">\n                ';
 if(agent.photo_attribution.photo) { 
__p+='\n                  <div class="media">\n                    <div class="branding-photo agent-photo media-img-wrapper">\n                      <img src="'+
((__t=( agent.photo_attribution.photo ))==null?'':__t)+
'" alt="This listing is presented by '+
((__t=( agent.details.name ))==null?'':__t)+
'" class="absolute-centering">\n                    </div>\n                  </div>\n                ';
 } 
__p+='\n                <div class="content ellipsis">\n                  ';
 if(agent.details.name) { 
__p+='\n                  <span class="font-size-small agent-name" itemscope itemtype="http://schema.org/RealEstateAgent">\n                    <span class="ellipsis link-secondary">\n                      <span class="hidden-qv-xs display-block">Presented by:</span>\n                      <span class="visible-qv-xs-inline font-bold">By</span>\n                      <span data-label="branding-agent-name" itemprop="name" class="font-bold qv-branding-link">'+
((__t=( agent.details.name ))==null?'':__t)+
'</span>\n                      <meta itemprop="image" content="'+
((__t=( agent.photo_attribution.photo ))==null?'':__t)+
'" class="qv-branding-link">\n                      ';
 if(agent.details.phone) { 
__p+='\n                        <span class="visible-qv-sm-inline visible-qv-md-inline visible-qv-lg-inline font-bold qv-branding-link" data-label="branding-agent-phone">'+
((__t=( agent.details.phone ))==null?'':__t)+
'</span>\n                        <a href="tel:'+
((__t=( agent.details.phone ))==null?'':__t)+
'" class="phone-tracking visible-qv-xs-inline font-bold qv-branding-link" data-phone-number="'+
((__t=( agent.details.phone ))==null?'':__t)+
'" data-label="branding-agent-phone-mobile">'+
((__t=( agent.details.phone ))==null?'':__t)+
'</a>\n                      ';
 } 
__p+='\n                    </span>\n                  </span>\n                  ';
 } 
__p+='\n                  ';
 if(agent.photo_attribution.slogan) { 
__p+='\n                    <span class="font-size-small display-block branding-slogan">\n                      <span class="ellipsis" data-label="branding-agent-slogan">'+
((__t=( agent.photo_attribution.slogan ))==null?'':__t)+
'</span>\n                    </span>\n                  ';
 } 
__p+='\n                </div>\n              </div>\n            </div>\n          ';
 } 
__p+='\n          ';
 if(office) { 
__p+='\n            <div class="col-qv-md-6 hidden-qv-sm hidden-qv-xs branding-wrapper">\n              <div class="component_business-card business-card-md '+
((__t=( office.photo_attribution.photo? '': 'no-media' ))==null?'':__t)+
'">\n                ';
 if(office.photo_attribution.photo) { 
__p+='\n                  <div class="media">\n                    <div class="branding-photo office-photo media-img-wrapper">\n                      <img src="'+
((__t=( office.photo_attribution.photo ))==null?'':__t)+
'" alt="This listing is presented by '+
((__t=( office.details.name ))==null?'':__t)+
'" class="absolute-centering">\n                    </div>\n                  </div>\n                  ';
 } 
__p+='\n                  <div class="content ellipsis">\n                    ';
 if(office.details.name) { 
__p+='\n                      <span class="font-size-small broker-name">\n                        <span class="display-block">Brokered by:</span>\n                        <span class="font-bold ellipsis display-block qv-branding-link" data-label="branding-office-name">\n                          '+
((__t=(office.details.name ))==null?'':__t)+
' ';
 if(office.photo_attribution && office.photo_attribution.phone) { 
__p+=' '+
((__t=( office.photo_attribution.phone ))==null?'':__t)+
' ';
 } 
__p+='\n                        </span>\n                      </span>\n                    ';
 } 
__p+='\n                    ';
 if(office.photo_attribution.slogan) { 
__p+='\n                      <span class="branding-slogan display-block font-size-small">\n                        <span class="ellipsis" data-label="branding-office-slogan">\n                          '+
((__t=( office.photo_attribution.slogan ))==null?'':__t)+
'\n                        </span>\n                      </span>\n                    ';
 } 
__p+='\n                  </div>\n                </div>\n              </div>\n            ';
 } 
__p+='\n        </div>\n      </div>\n    ';
 } else if(is_essentials && office) { 
__p+='\n      <div class="clearfix">\n        <div class="essentials-branding branding-wrapper">\n          <div class="component_business-card business-card-md '+
((__t=( office.photo_attribution.photo? '' : 'no-media' ))==null?'':__t)+
'  no-media-xs ">\n            ';
 if(office.photo_attribution.photo) { 
__p+='\n              <div class="media">\n                <div class="branding-photo office-photo hidden-qv-xs media-img-wrapper">\n                  <img src="'+
((__t=( office.photo_attribution.photo ))==null?'':__t)+
'" alt="This listing is presented by '+
((__t=( office.details.name ))==null?'':__t)+
'" class="absolute-centering">\n                </div>\n              </div>\n            ';
 } 
__p+='\n            <div class="content ellipsis">\n              ';
 if(agent && agent.details.name) { 
__p+='\n                <span itemscope itemtype="http://schema.org/RealEstateAgent" class="agent-name font-size-small">\n                  <span class="hidden-qv-xs">Presented by: </span>\n                  <span class="visible-qv-xs-inline">By </span>\n                  <span class="font-bold qv-branding-link" itemprop="name" data-label="branding-agent-name">'+
((__t=( agent.details.name ))==null?'':__t)+
'</span>\n                  <meta itemprop="image" content="'+
((__t=( agent.photo_attribution.link ))==null?'':__t)+
'">\n                </span>\n              ';
 } 
__p+='\n              ';
 if(office.details.name) { 
__p+='\n                <span class="font-size-small">\n                  <span class="hidden-qv-xs">Brokered by: </span>\n                  ';
 if(agent && agent.details.name) { 
__p+='\n                    <span class="visible-qv-xs-inline qv-branding-link"> with </span>\n                  ';
 } 
__p+='\n                  <span class="font-bold qv-branding-link" data-label="branding-office-name"> '+
((__t=(office.details.name ))==null?'':__t)+
'</span>\n                </span>\n              ';
 } 
__p+='\n            </div>\n          </div>\n        </div>\n      </div>\n    ';
 } else if (is_basic && (agent || office) && ((office.details && office.details.name) || (agent.details && agent.details.name))) { 
__p+='\n      <div class="font-size-small basic-branding ellipsis">\n        <span class="hidden-qv-xs display-block">Presented by:</span>\n        <span class="visible-qv-xs-inline">By</span>\n        ';
 if (agent.details.name) { 
__p+='\n          <span class="qv-branding-link" itemscope itemtype="http://schema.org/RealEstateAgent">\n            <span class="font-bold" itemprop="name" data-label="branding-agent-name">'+
((__t=( agent.details.name ))==null?'':__t)+
'</span>\n            <meta itemprop="image" content="'+
((__t=( agent.photo_attribution.link ))==null?'':__t)+
'">\n          </span>\n        ';
 } 
__p+='\n        ';
 if(agent.details.name && office.details.name) {
__p+='<span class="qv-branding-link"> with </span>';
 } 
__p+='\n        ';
 if(office.details.name) { 
__p+='\n          <span class="font-bold qv-branding-link" data-label="branding-office-name"> '+
((__t=(office.details.name ))==null?'':__t)+
'</span>\n        ';
 } 
__p+='\n      </div>\n    ';
 } 
__p+='\n  ';
 } else if(property_type == "new_plan" && builder_branding) { 
__p+='\n    <div class="row pos-relative">\n      <div class="branding-bar"></div>\n      <div class="col-qv-xs-12 wrapper ';
 builder_branding.photo? '' : 'no-media' 
__p+='">\n        <div class="component_business-card business-card-md no-media-xs">\n          ';
 if(builder_branding.photo) { 
__p+='\n            <div class="media">\n              <div class="branding-photo office-photo hidden-qv-xs media-img-wrapper">\n                <img src="'+
((__t=( builder_branding.photo ))==null?'':__t)+
'" alt="This listing is presented by '+
((__t=( builder_branding.name ))==null?'':__t)+
'" class="absolute-centering">\n              </div>\n            </div>\n          ';
 } 
__p+='\n          <div class="content ellipsis new-plans-branding">\n            <div class="display-block qv-branding-link">\n              ';
 if(builder_branding.name) { 
__p+='\n                <span itemscope itemtype="http://schema. org/RealEstateAgent" class="agent-name font-size-small">\n                  <span class="hidden-qv-xs display-block">Built by:</span>\n                  <span class="visible-qv-xs-inline">By</span>\n                  <span class="font-bold qv-branding-link" itemprop="name" data-label="branding-agent-name">\n                    '+
((__t=( builder_branding.name ))==null?'':__t)+
'\n                    ';
 if(builder_branding.phone_number) { 
__p+='<span class="hidden-qv-xs">'+
((__t=( builder_branding.phone_number ))==null?'':__t)+
'</span> ';
 } 
__p+='\n                  </span>\n                  <meta itemprop="image" content="'+
((__t=( builder_branding.photo ))==null?'':__t)+
'">\n                </span>\n              ';
 } 
__p+='\n              ';
 if(builder_branding.phone_number) { 
__p+='\n                <span class="branding-slogan font-size-small font-bold visible-qv-xs-block padding-top link-nostyle">\n                  <span class="ellipsis" data-label="branding-office-slogan">\n                    <a href="tel:'+
((__t=( builder_branding.phone_number ))==null?'':__t)+
'" class="phone-tracking" data-phone-number="'+
((__t=( builder_branding.phone_number ))==null?'':__t)+
'" data-label="branding-builder-phone-mobile">\n                      <i class="ra ra-phone"></i> '+
((__t=( builder_branding.phone_number ))==null?'':__t)+
'\n                    </a>\n                  </span>\n                </span>\n              ';
 } 
__p+='\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  ';
 } 
__p+='\n</div>\n';
return __p;
};



// WEBPACK FOOTER //
// ./quick_view/templates/qv-branding.jst.ejs